import React, { useCallback, useState, useRef } from 'react'
import { Formik } from 'formik';
import * as Yup from "yup";
import clsx from "clsx";
import { isEmptyObject } from 'app/utils/IsEmptyObject';
import globalMU from 'globalMU';
import { Separador } from 'app/components/separador/Separador';

const estilosInput = require('../../../estilos/inputs.module.scss').default
const estilosBotoes = require('../../../estilos/botoes.module.scss').default

export type SenhaMarkupProps = {
    onBotaoOkClicado: (senha: string) => void
}

export const SenhaMarkup = (props: SenhaMarkupProps) => {
    const isMounted = useRef(true);
    const [isCapsLockOn, setIsCapsLockOn] = useState(false)

    React.useEffect(() => {
        isMounted.current = true;
        
        return () => {
            isMounted.current = false;
        };
    }, []);

    const schema = React.useMemo(() => 
        Yup.object().shape({
            senha: Yup.string().required("Campo senha é obrigatório"),
        })
    , [])

    const converterErroObjToList = useCallback((erros) => {
        let mensagemErro = "";
        for (const [key, value] of Object.entries(erros)) {
             mensagemErro += value + '\n'
        }
        return mensagemErro
    }, [])

    const tratarErros = useCallback(async (values, validateForm, handleSubmit) => {
        const erros = await validateForm(values)
        if (isMounted.current) {
            isEmptyObject(erros) ? handleSubmit() : globalMU.showErrorMessage(converterErroObjToList(erros))
        }
    }, [converterErroObjToList])

    const checkCapsLock = useCallback((event) => {
        if (event && typeof event.getModifierState === 'function' && isMounted.current) {
            setIsCapsLockOn(event.getModifierState('CapsLock'));
        }
    }, [])

    const handleCapsLockBlur = useCallback(() => {
        if (isMounted.current) {
            setIsCapsLockOn(false);
        }
    }, [])

    const handleButtonFocus = useCallback(() => {
        if (isMounted.current) {
            setIsCapsLockOn(false);
        }
    }, [])

    const handleSubmit = useCallback((values, validateForm, handleSubmitForm) => {
        return async (e) => {
            e.preventDefault()
            await tratarErros(values, validateForm, handleSubmitForm)
        }
    }, [tratarErros])

    const renderForm = useCallback(({
        values,
        handleChange,
        handleSubmit: handleSubmitForm,
        validateForm
    }) => (
        <form onSubmit={handleSubmit(values, validateForm, handleSubmitForm)}
            id="SenhaMarkup_Form"
        >
            <div className='_grid _grid-cols-1 md:_grid-cols-[160px_auto] _items-stretch _font-normal _text-[#333739]'>
                <div className='_text-right _py-1 _pr-4'
                 id="SenhaMarkup_TituloSenha"
                 title="Permissão: [Libera consulta do markup no orçamento]"
                >Senha <span className={estilosInput.obrigatorio}>*</span></div>
                <div className='_mb-4 _place-self-end md:_place-self-start'>
                    <input
                     id="SenhaMarkup_InputSenha"
                    type="password"
                    value={(values.senha) ?? ""}
                    onChange={handleChange('senha')}
                    className={clsx(`_w-[190px] ${estilosInput.inputPadrao}`)}
                    autoFocus
                    autoComplete="off"
                    aria-autocomplete="none"
                    list="autocompleteOff" // para naos mostrar dados digitados anteriormente
                    onKeyUp={checkCapsLock}
                    onFocus={checkCapsLock}
                    onBlur={handleCapsLockBlur}
                    />
                     {isCapsLockOn && (
                            <span
                                style={{ color: "red", fontWeight: "bold", }}>&nbsp;&nbsp;CapsLock está ativado</span>
                        )}
                </div>
                <button className={clsx(`no-global-button _w-[44px] _place-self-start ${estilosBotoes.botaoPrimario}`)}
                     id="SenhaMarkup_BotaoOk"
                     onFocus={handleButtonFocus}
                >Ok</button>
            </div>
        </form>
    ), [checkCapsLock, handleCapsLockBlur, handleButtonFocus, handleSubmit, isCapsLockOn])

    
    return <>
        <Separador />
        <Formik
            initialValues={{ senha: "" }}
            onSubmit={(values) => {
                props.onBotaoOkClicado(values.senha)
            }}
            validationSchema={schema}
        >
            {renderForm}
        </Formik>
    </>
}